export default __webpack_public_path__ + "static/media/img-evpower-default.6daeb04a.svg";